var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PagerItemDisabled, PagerLinkDisabled, PagerItemActive, PagerItem, PagerLink } from '../../Table.styled';
import { getAutomation, useMobile } from '@citrus/runtime';
import { getVisiblePages } from './utils';
var PageLinks = function (_a) {
    var automationId = _a.automationId, disabled = _a.disabled, goToPage = _a.goToPage, itemCount = _a.itemCount, numberOfVisiblePages = _a.numberOfVisiblePages, page = _a.page, pageCount = _a.pageCount, pageSize = _a.pageSize;
    var mobile = useMobile(700);
    if (itemCount <= 0 || itemCount <= pageSize)
        return null;
    var visiblePages = getVisiblePages(mobile, numberOfVisiblePages, page, pageCount);
    if (disabled) {
        return visiblePages.map(function (x, index) { return (React.createElement(PagerItemDisabled, { key: "pcty-item-".concat(automationId || '', "-").concat(index) },
            React.createElement(PagerLinkDisabled, __assign({}, getAutomation(automationId, 'page' + x)), x))); });
    }
    return visiblePages.map(function (x, index) {
        var Component = x === page ? PagerItemActive : PagerItem;
        return (React.createElement(Component, { key: "pcty-item-".concat(automationId || '', "-").concat(index), onClick: x === page ? undefined : function (e) { return goToPage(x, e); } }, x === page ? (x) : (React.createElement(PagerLink, __assign({ onClick: function (e) { return goToPage(x, e); } }, getAutomation(automationId, 'page' + x)), x))));
    });
};
export default PageLinks;
